import React, { useMemo } from 'react';
import { Button, Dropdown, message, Tooltip } from 'antd';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import { LinkIcon, CopySecondaryIcon, SuccessIcon, ActionIcon } from '@icons';
import { useGetApprovalWorkflow } from '@hooks/queries/approval';

import './ApprovalAssetsListActionMenu.less';

type ApprovalAssetsListActionMenuProps = {
  approvalWorkflowId?: string;
  password?: string | null;
};

function ApprovalAssetsListActionMenu({
  approvalWorkflowId,
  password
}: ApprovalAssetsListActionMenuProps) {
  const { data } = useGetApprovalWorkflow({
    enabled: false,
    params: {
      id: approvalWorkflowId || '',
      password
    }
  });
  const approvalWorkflow = data?.approvalWorkflow;

  const menuItems = useMemo((): ItemType[] => {
    if (!approvalWorkflow) return [];
    return [
      {
        key: 'copy-approval-link',
        icon: <LinkIcon style={{ padding: 2 }} />,
        label: (
          <Tooltip
            overlayClassName="toggle_favorite_overlay"
            title="Only reviewers in this approval can access this link"
            placement="right"
          >
            <span>Copy approval link</span>
          </Tooltip>
        ),
        onClick: () => {
          navigator.clipboard.writeText(approvalWorkflow.url);
          message.success({
            content: 'Copied link to clipboard',
            className: 'message-dark-modal',
            icon: <SuccessIcon className="anticon" />
          });
        }
      },
      {
        key: 'copy-approval-id',
        icon: <CopySecondaryIcon />,
        label: 'Copy Approval ID',
        onClick: () => {
          navigator.clipboard.writeText(approvalWorkflow.id);
          message.success({
            content: 'Approval ID copied to clipboard',
            className: 'message-dark-modal',
            icon: <SuccessIcon className="anticon" />
          });
        }
      }
    ];
  }, [approvalWorkflow]);

  if (!approvalWorkflow) return null;

  return (
    <Dropdown
      menu={{
        items: menuItems,
        selectable: false
      }}
      trigger={['click']}
      placement="bottomRight"
      overlayClassName="approval-assets-list-action-menu-overlay"
    >
      <Button className="media_viewer_btn b-only-icon">
        <ActionIcon />
      </Button>
    </Dropdown>
  );
}

export default ApprovalAssetsListActionMenu;
